import HttpService from '@src/utility/httpService';
import { config } from '@uhg-abyss/web/tools/config';
import { checkIsInternal} from '@src/utility/createStorage';
import {ADVANCE_SEARCH_API_URL} from './apiURL';

const _httpService = new HttpService();

if (checkIsInternal()) {
  _httpService.setBaseURL(config('API_DOMAIN_INTERNAL'));
} else {
  _httpService.setBaseURL(config('API_DOMAIN_EXTERNAL'));
}

export const getAdvanceSearchData = async (payload)=>{
    const URL = ADVANCE_SEARCH_API_URL;
    try {
        const responseData: any = await _httpService.push(URL, payload);
        return responseData?.Data;
    } catch (error){
        console.error("Error Fetching Advance Search Dropdown Data");
        return [];
    }
}